import { SwitchProps } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import {
  Control,
  FieldError,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';

import { LabelPosition } from 'core/enums';
import { Size } from 'theme/enums';

import { SwitchInputView } from './SwitchInputView';
import { SwitchInputWithControllerView } from './SwitchInputWithControllerView';

interface IExtraFormFieldProps {
  setValue?: UseFormSetValue<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
}

export interface IProps extends Omit<SwitchProps, 'size' | 'defaultValue'>, IExtraFormFieldProps {
  control?: Control<FieldValues, object>;
  error?: FieldError;
  name?: string;
  defaultValue?: boolean;
  label?: string | string[] | JSX.Element;
  onKeyDown?: (event) => void;
  onChange?: (event) => void;
  size?: Size;
  labelSx?: SxProps;
  wrapperSx?: SxProps;
  labelPosition?: LabelPosition;
  disabledTooltip?: string;
}

export const SwitchInput = (props: IProps) => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { setValue, getValues, ...other } = props;

  if (props?.control) {
    return <SwitchInputWithControllerView {...other} />;
  }

  return <SwitchInputView {...other} />;
};
